import { X } from "lucide-react";

export default function QuickFilterModal({ isOpen, filter, ghlAttendees, kixieAttendees, onChange, onClose, onClear, onApply }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md p-5">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-sm font-semibold text-gray-800">Quick Filters</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 text-lg">
            <X size={15} />
          </button>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs text-gray-500 mb-1">From Date</label>
            <input type="date" value={filter.from} onChange={(e) => onChange({ ...filter, from: e.target.value })} className="w-full border rounded-lg px-3 py-2 text-sm" />
          </div>
          <div>
            <label className="block text-xs text-gray-500 mb-1">To Date</label>
            <input type="date" value={filter.to} onChange={(e) => onChange({ ...filter, to: e.target.value })} className="w-full border rounded-lg px-3 py-2 text-sm" />
          </div>
          <div>
            <label className="block text-xs text-gray-500 mb-1">GHL Agent</label>
            <select value={filter.agent} onChange={(e) => onChange({ ...filter, agent: e.target.value })} className="w-full border rounded-lg px-3 py-2 text-sm">
              <option value="">Select GHL Agent</option>
              {(ghlAttendees || []).map((agent, index) => (
                <option key={`ghl-${index}`} value={agent}>
                  {agent || "Unknown"}
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-xs text-gray-500 mb-1">Kixie Agent</label>
            <select value={filter.kixieAgent || ""} onChange={(e) => onChange({ ...filter, kixieAgent: e.target.value })} className="w-full border rounded-lg px-3 py-2 text-sm">
              <option value="">Select Kixie Agent</option>
              {(kixieAttendees || []).map((agent, index) => (
                <option key={`kixie-${index}`} value={agent}>
                  {agent || "Unknown"}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="flex justify-end gap-2 mt-5">
          <button onClick={onClear} className="px-4 py-2 min-w-32 text-sm rounded-md shadow-sm border hover:bg-gray-200 duration-200 ease-in-out">
            Clear
          </button>
          <button onClick={onApply} className="px-4 py-2 min-w-32 text-sm rounded-md shadow-sm bg-sky-400 hover:bg-sky-600 duration-200 ease-in-out text-white">
            Apply
          </button>
        </div>
      </div>
    </div>
  );
}
